/* eslint-disable no-script-url */
import React, { FC, useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import DetailPageInfo from "src/components/detailPageInfo";
import AddNote from "src/components/modals/addNote";
import AddNonCaseNote from "src/components/modals/addNonCaseTreatment";
import RequestDateOfTreatment from "src/components/modals/requestDateOfTreatment";
import CancelTreatment from "src/components/modals/cancelTreatment";

import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { GlobalPatientDetailType } from "./types";


import { LoaderContext } from "src/context/loaderContext";
import { PATIENT_DETAIL_CASE } from "src/types/case";
import KAMFAMNotes from "src/components/kamfamNotes";
import FooterText from "../../components/footerText";
import { AuthContext } from "src/context/authContext";
import RefillData from "src/components/manufacturer/refillData";





const GlobalPatient: FC = (): JSX.Element => {
  const { patientId, caseId } = useParams();
  const { hideLoader } = useContext(LoaderContext);
    const { userData } = useContext(AuthContext);


  const [saveNoteModal, setDataforNoteModal] = useState<{ isModalVisible: boolean; caseId: number; }>({
    isModalVisible: false,
    caseId: 0,
  });
  const [showRequestTreatmentModal, setDataForRequestModalTreatment] = useState<{ isModalVisible: boolean; caseId: number; prescriptionId: number, bentype: string; investigated_at: string; }>({
    isModalVisible: false,
    caseId: 0,
    prescriptionId: 0,
    investigated_at: "",
    bentype: ''
  });
  const [cancelTreatmentModal, setDataForCancelModal] = useState<{ isModalVisible: boolean; caseId: number; prescriptionId: number }>({
    isModalVisible: false,
    caseId: 0,
    prescriptionId: 0
  });
  const [NonCaseNoteModal, setDataforNonCaseNoteModal] = useState<{ isModalVisible: boolean; patientId: number; }>({
    isModalVisible: false,
    patientId: 0,
  });

  const refreshValue = () => {
    GlobalPatientDetailMutate({}, { patientId: patientId }, { case_id: caseId })
  }




  const { data: GlobalPatientDetailObject, error: GlobalPatientDetailError, mutate: GlobalPatientDetailMutate } =
    useFetch<GlobalPatientDetailType>(APIEndpoints.GET_GLOBAL_PATIENT_DETAIL_BY_ID, { case_id: caseId }, { patientId: patientId });

  useEffect(() => {
    if (GlobalPatientDetailObject || GlobalPatientDetailError) {
      hideLoader();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [GlobalPatientDetailObject, GlobalPatientDetailError]);

const AddNoteDisbaled = () => {
    if(userData?.ref_type === "rep" ){
      return false;
    }else{
      return true;
    }
  }


    return (
        <section className="overflow-y-auto overflow-x-hidden d-flex flex-column flex-fill">
            <div className="container-fluid pt-3 d-flex flex-column flex-fill">
                <div className="row mb-3 align-items-center">
                    <div className="col-sm-4 col-12">
                        <h2 className="m-0">Patient ID <span className="badge bg-primary rounded-5">{patientId}</span></h2>
                        <div>
                            <span>
                                <i className="bi bi-graph-up-arrow"></i>&nbsp;&nbsp;
                                <b>BIs:</b> {GlobalPatientDetailObject?.data?.info?.bi}
                            </span>,&nbsp;&nbsp;
                            <span>
                                <i className="bi bi-capsule-pill"></i>&nbsp;&nbsp;
                                <b>Treatments:</b> {GlobalPatientDetailObject?.data?.info?.treatments}
                            </span>
                        </div>
                    </div>
                    <div className="col-sm-8 col-12 text-md-end">
                        <div
                            className={`d-inline-flex px-3 text-center text-white fs-4 rounded-3 background-color-${GlobalPatientDetailObject?.data?.info?.status_color}`}>
                            {GlobalPatientDetailObject?.data?.info?.status_name}
                        </div>
                    </div>
                </div>

                {GlobalPatientDetailObject &&
                    <div className="my-3">
                        <DetailPageInfo
                            benefit_summary={GlobalPatientDetailObject && GlobalPatientDetailObject.data && GlobalPatientDetailObject.data.benefit_summary}
                            coverage_summary={GlobalPatientDetailObject && GlobalPatientDetailObject.data && GlobalPatientDetailObject.data.coverage_summary && GlobalPatientDetailObject.data.coverage_summary}
                            drug_name="" isPatient
                        />
                    </div>
                }
                {GlobalPatientDetailObject && GlobalPatientDetailObject.data && GlobalPatientDetailObject.data.refill_data ? (
                    <RefillData refill_data={GlobalPatientDetailObject.data.refill_data} />
                ) : null}
                {GlobalPatientDetailObject && GlobalPatientDetailObject.data && GlobalPatientDetailObject.data.kam_fam_notes &&
                    <div className="my-3">
                        <KAMFAMNotes
                            add_note={GlobalPatientDetailObject.data.kam_fam_notes.add_note}
                            caseId={GlobalPatientDetailObject.data.kam_fam_notes.case_id}
                            kamfamNotes={GlobalPatientDetailObject.data.kam_fam_notes.notes.map((item, index) => ({
                                id: index,
                                description: item.desc, ...item
                            }))}
                            drug_name=""
                            updateKamfamNotes={() => {
                            }}
                            isPatient
                        />
                    </div>
                }

                <div className="card my-3">
                    <div className="card-header">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h4 className="mb-0">Cases</h4>
                            {/* <button className="btn btn-success btn-sm"
                        onClick={() => {
                          patientId && setDataforNonCaseNoteModal({
                            isModalVisible: true,
                            patientId: parseInt(patientId)
                          })
                        }}>
                  Add Tx Date If No BI
                </button> */}
                        </div>
                    </div>
                    <div className="card-body p-0">
                        <div
                            className="table-responsive"
                            style={(GlobalPatientDetailObject?.data?.case_list?.length ?? 0) > 10 ? { maxHeight: 600, overflowY: "auto" } : undefined}
                        >
                            <table className="table table-striped table-hover">
                                <thead className="sticky-top">
                                <tr className="text-center">
                                    {PATIENT_DETAIL_CASE.map((head, index) => (
                                        <th style={head.label.toLowerCase() === "status" ? { width: 300 } : {}} key={index}>{head.label}</th>
                                    ))}
                                </tr>
                                </thead>
                                <tbody>
                                {GlobalPatientDetailObject && GlobalPatientDetailObject.data && GlobalPatientDetailObject.data.case_list && GlobalPatientDetailObject.data.case_list.length > 0 ?
                                    GlobalPatientDetailObject.data.case_list.map((data, index) => (
                                        <tr key={index}>
                                            <td className="text-center align-middle">
                                                <Link to={`/cases/detail/${data.bi_case_id}`}>{data.bi_case_id}</Link>
                                            </td>
                                            <td className="text-center align-middle">{data.created}</td>
                                            <td className="text-center align-middle">{data.treated}</td>
                                            <td className="text-center align-middle">{data.provider}</td>
                                            <td className={`text-center align-middle ${data.status_color} text-white`}>
                                                {data.status}
                                            </td>
                                            {/* <td className="text-center align-middle">
                                                {data.release_order && (
                                                    <button
                                                        className="btn btn-success m-1 text-white"
                                                        disabled={!data.transfer_to_rx}
                                                        onClick={() => setDataForRequestModalTreatment({ isModalVisible: true, caseId: data.bi_case_id, prescriptionId: data.prescription_id, bentype: '', investigated_at: data.investigated_at || '' })}
                                                    >
                                                        <i className="fa fa-clipboard"></i> Release Order
                                                    </button>
                                                )}
                                                {data.review_case_notes && (
                                                    <p className="fs-6 mb-0">Review Case Notes</p>
                                                )}
                                               
                                            </td> */}
                                            <td className="text-center align-middle">
                                                {data.not_treated_reason ?
                                                    <span>{data.not_treated_reason}</span>
                                                    : null}
                                            </td>
                                            {/* <td className="text-center align-middle">
                                                {(
                                                        <button type="button" className="btn btn-success btn-sm"
                                                                disabled={AddNoteDisbaled()}
                                                                onClick={() => {
                                                                    setDataforNoteModal({isModalVisible: true, caseId: data.bi_case_id})
                                                                }}>
                                                            {'AddNote'}
                                                        </button>
                                                    )
                                                    // eslint-disable-next-line jsx-a11y/anchor-is-valid

                                                }
                                            </td> */}
                                        </tr>
                                    ))
                                    : null}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <AddNote
                    isModalVisible={saveNoteModal.isModalVisible}
                    caseId={saveNoteModal.caseId}
                    refreshListing={(note) => refreshValue()}
                    hideModal={() => {
                        setDataforNoteModal({
                            isModalVisible: false,
                            caseId: 0,
                        });
                    }}
                />
                <AddNonCaseNote
                    isModalVisible={NonCaseNoteModal.isModalVisible}
                    patientName={NonCaseNoteModal.patientId.toString()}
                    refreshListing={refreshValue}
                    hideModal={() => {
                        setDataforNonCaseNoteModal({
                            isModalVisible: false,
                            patientId: 0,
                        });
                    }}
                />
                <RequestDateOfTreatment
                    isModalVisible={showRequestTreatmentModal.isModalVisible}
                    caseId={showRequestTreatmentModal.caseId}
                    prescriptionId={showRequestTreatmentModal.prescriptionId}
                    bentype={showRequestTreatmentModal.bentype}
                    investigated_at={showRequestTreatmentModal.investigated_at || ""}
                    hideModal={() => {
                        setDataForRequestModalTreatment({
                            isModalVisible: false,
                            caseId: 0,
                            prescriptionId: 0,
                            bentype: '',
                            investigated_at: "",
                        });
                    }}
                    refreshListing={() => {
                        // handleSearchWithQueryParam();
                    }}
                />
                <CancelTreatment
                    isModalVisible={cancelTreatmentModal.isModalVisible}
                    caseId={cancelTreatmentModal.caseId}
                    prescriptionId={cancelTreatmentModal.prescriptionId}
                    hideModal={() => {
                        setDataForCancelModal({
                            isModalVisible: false,
                            caseId: 0,
                            prescriptionId: 0
                        });
                    }}
                    refreshListing={() => {
                        //handleSearchWithQueryParam();
                    }}
                />
            </div>
            <FooterText footerType="black"/>
        </section>
    );
};

export default GlobalPatient;
